// removed by extract-text-webpack-plugin
module.exports = {"columns":"src-modules-orders-OrderScheduleForm-__OrderScheduleForm__columns--glRiz","column-calendar":"src-modules-orders-OrderScheduleForm-__OrderScheduleForm__column-calendar--22sAS","column-dates":"src-modules-orders-OrderScheduleForm-__OrderScheduleForm__column-dates--23Vnf"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/orders/OrderScheduleForm/OrderScheduleForm.less
// module id = 1888
// module chunks = 0